<div class="panel panel-default">
    <div class="panel-body">
        
        <div *ngIf="!existeAlMenosUnaColumnaAMostrar()">
            <div class="alert alert-danger" role="alert">
                Ooops! No hay ninguna columna a mostrar. Por favor, seleccione al menos una columna a mostrar.
            </div>
        </div>

        <div>

            <app-datatable-paginacion-limit
                [calculatingTotal]="calculatingTotal"
                [datatable]="datatable"
                [size]="size"
                [page]="page"
                [total]="total"
                (onPageCambiada)="paginaCambiada($event)"
                (onSizeCambiado)="sizeCambiado($event)"
            >
                <div class='right-content d-inline-block text-right'>
                    <app-datatable-excel-descargar
                        class='boton-cabecera'
                        *ngIf="datatable.excels && datatable.excels.length > 0"
                        [filtros]="filtros"
                        [sorts]="sorts"
                        [datatable]="datatable"
                    ></app-datatable-excel-descargar>
                    <app-datatable-filtro-magico
                        class='boton-cabecera'
                        *ngIf="datatable.filtrosMagicos"
                        [id]="id"
                        [datatable]="datatable"
                        (onFiltrosCambiados)="filtrosCambiados($event)"
                        (onBotonFiltrarPresionado)="filtrosCambiados($event)"
                    >
                    </app-datatable-filtro-magico>
                    <app-datatable-mostrar-columnas 
                        class='boton-cabecera'
                        *ngIf="datatable.mostrarSeleccionadorColumnas"
                        [id]="id"
                        [datatable]="datatable"
                    ></app-datatable-mostrar-columnas>
                </div>
            </app-datatable-paginacion-limit>

            <div class='row' *ngIf="datatable.filtrosMagicos">
                <div class='col-md-12 text-left'>
                    <div class='text-left'>
                        <app-datatable-filtro-lista 
                            [id]="id"
                            [filtros]="filtros" 
                            [rebuild]="rebuildFiltros" 
                            [filtrosMagicos]="datatable.filtrosMagicos"
                        >
                        </app-datatable-filtro-lista>
                    </div>
                </div>
            </div>

            <div class='row'>
                <div class='col-md-6 text-left'>
                    <div class='text-left' *ngIf="(!loading || sorts.length > 0) && total > 0 && (datatable.sortMaximos == null || datatable.sortMaximos > 0)">
                        <app-datatable-sort-lista 
                            [datatable]="datatable"
                            [sorts]="sorts"
                            (onSortCambiados)="sortCambiados($event)"
                        ></app-datatable-sort-lista>
                    </div>
                </div>
                <div class='col-md-6 text-right'>
                    <div class='text-right' *ngIf="!loading && !calculatingTotal && datatable.paginacion.mostrarCantidadRegistros !== false" [ngClass]="total == 0 ? 'texto-no-registros' : ''">
                        <p>Se han encontrado {{total}} registros.</p>
                    </div>

                    <div class='text-right' *ngIf="loading || calculatingTotal" [ngClass]="total == 0 ? 'texto-no-registros' : ''">
                        <p>Actualizando registros...</p>
                    </div>
                </div>
            </div>
            
            <app-datatable-table
                [id]="id"
                [datatable]="datatable"
                [loading]="loading"
                [data]="data"
                [sorts]="sorts"
                (onSortCambiados)="sortCambiados($event)"
            ></app-datatable-table>

            <div class='text-right' *ngIf="!loading && !calculatingTotal && datatable.paginacion.mostrarCantidadRegistros !== false">
                <p>Se han encontrado {{total}} registros.</p>
            </div>

            <app-datatable-paginacion-limit
                [calculatingTotal]="calculatingTotal"
                [datatable]="datatable"
                [size]="size"
                [page]="page"
                [total]="total"
                (onPageCambiada)="paginaCambiada($event)"
                (onSizeCambiado)="sizeCambiado($event)"
            ></app-datatable-paginacion-limit>

        </div>
    </div>
</div>
